import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const api = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_BASE_URL }),
  reducerPath: "iduploadApi",
  tagTypes: ["Idupload", "Reservation"],
  endpoints: (build) => ({
    fetchReservationInfo: build.query({
      query: (id) => `idupload/fetch/${id}`,
      providesTags: ["Reservation"],
    }),
    submitIdUpload: build.mutation({
      query: ({ id, groupInfo, reservationInfo }) => ({
        url: `idupload/input/${id}`,
        method: "POST",
        body: { groupInfo, reservationInfo },
      }),
      invalidatesTags: ["Idupload"],
    }),
    autoSave: build.mutation({
      query: ({ id, debouncedFormdata }) => ({
        url: `idupload/autosave/${id}`,
        method: "POST",
        body: { debouncedFormdata },
      }),
    }),
  }),
});

export const { 
  useFetchReservationInfoQuery,
  useSubmitIdUploadMutation,
  useAutoSaveMutation,
} = api; 